module.exports = __webpack_public_path__ + "static/media/web_hand4.6ccf951b.png";